// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__BgVcM","title":"FrontImage_title__3bkKn"};